<script lang="tsx">
import { defineComponent, type PropType } from 'vue'
import { createNamespace } from '@bd/vue3-utils'
import { Table, type TableColumnType } from 'ant-design-vue'
import { useNoResettlePrice } from '../../useNoResettlePrice'
import MainPriceCell from '../MainPriceCell.vue'
import TotalAmountCell from '../TotalAmountCell.vue'
const [name] = createNamespace('RewardNoResettleEntryForm')
export default defineComponent({
  name,
  props: {
    dataSync: {
      type: Object as PropType<Partial<ApiJtZch.CompData>>
    },
    standard: {
      type: Object as PropType<Partial<ApiJtProj.CompStandardData>>
    },
    members: {
      type: Array as PropType<ApiFamilyMembers.Item[]>,
      default: () => []
    }
  },
  setup(props, { expose }) {
    const {
      standardRate,
      zhuanHunXianJiaoJieGouPrice,
      zhuanHunYuZhiJieGouPrice,
      zhuanMuJieGouXiaoQingWaPrice,
      tuMuMuJieGouPrice,
      qiTaJieGouPrice,
      mainAmount,
      totalAmount
    } = useNoResettlePrice(props.dataSync!, props.standard!, props.members)

    const renderStandardCell = () => (
      <span>
        拆迁奖励及搬迁补助按住房面积（不含生产经营性用房）补偿款的<b class='color-error'>{standardRate.value}%</b>计算。
      </span>
    )
    const columns: TableColumnType[] = [
      {
        title: '内容详解',
        dataIndex: 'nrxj',
        customRender() {
          return '以户为单位有合法宅基地、独立门牌号的整栋房屋需拆迁，家庭成员全部为非农户口不享受安置的，且在规定时间（时间由镇乡（街道）人民政府（办事处）根据项目具体情况规定）内签订拆迁协议的。'
        }
      },
      {
        title: '房屋主体补偿金额',
        dataIndex: 'ztbcje',
        width: 200,
        customRender() {
          return (
            <MainPriceCell
              zhuanHunXianJiaoJieGouPrice={zhuanHunXianJiaoJieGouPrice.value.toNumber()}
              zhuanHunYuZhiJieGouPrice={zhuanHunYuZhiJieGouPrice.value.toNumber()}
              zhuanMuJieGouXiaoQingWaPrice={zhuanMuJieGouXiaoQingWaPrice.value.toNumber()}
              tuMuMuJieGouPrice={tuMuMuJieGouPrice.value.toNumber()}
              qiTaJieGouPrice={qiTaJieGouPrice.value.toNumber()}
              mainAmount={mainAmount.value.toNumber()}
            />
          )
        }
      },
      {
        title: '单位',
        dataIndex: 'unit',
        width: 50,
        customRender() {
          return '元'
        }
      },
      {
        title: '标准',
        dataIndex: 'standard',
        customRender: renderStandardCell
      },
      {
        title: '金额（元）',
        dataIndex: 'amount',
        width: 100,
        customRender() {
          return <TotalAmountCell totalAmount={totalAmount.value} members={props.members} />
        }
      }
    ]
    expose({
      mainAmount,
      totalAmount
    })
    return () => <Table pagination={false} columns={columns} dataSource={[{}]} size='small' />
  }
})
</script>
